export const resetHasMore = () => ({
    type: 'RESET_HAS_MORE_RECIPE',
});